import { selectedDate } from "../actionTypes"

export const selectedDayReducer = (state = '', action) => {

   let { type, payload } = action

   switch (type) {
      case selectedDate.LOAD_SELECTED_DATE:
         return payload
      default:
         return state
   }
}

export const selectedEndDayReducer = (state = '', action) => {

   let { type, payload } = action

   switch (type) {
      case selectedDate.LOAD_SELECTED_END_DATE:
         return payload
      default:
         return state
   }
}